module.exports = __webpack_public_path__ + "img/IMG_1231_FoamcoreMatted.7686e69a.jpg";